<template>
	<footer class="container-fluid main-footer-go-ui">
		<span>&copy; Global Overview 2018- {{moment().year()}}</span>
	</footer>
</template>


<script>
	import moment from "moment";
	export default {
		methods: {
			moment
		}
	};
</script>

<style>
.main-footer-go-ui {
	position: relative;
	bottom: 0px;
}
</style>
